// src/docs/DocsLeavingCrowdLaunch.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";

const DocsLeavingCrowdLaunch = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Page Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 3 }}>
     External Links
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 3 }}>
        CrowdLaunch is designed to be your gateway to a variety of blockchain projects and services.
        However, there may be times when you need to access external sites for additional information,
        support, or project-specific updates. This guide explains what to expect when you click on external links,
        and how to do so safely.
      </Typography>

      {/* What Are External Links? */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        What Are External Links?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        External links are hyperlinks that will direct you away from CrowdLaunch to other websites or online resources.
        These may include official project websites, support forums, social media pages, or third-party review sites.
      </Typography>

      {/* Why Use External Links? */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Why Use External Links?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        External links offer additional information that may not be available directly on CrowdLaunch.
        They allow you to:
        <br />• Get in-depth updates and announcements directly from project teams.
        <br />• Access community forums and support channels.
        <br />• Visit official websites for further details on products, services, or upcoming events.
      </Typography>

      {/* Safety and Security */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Safety and Security
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        While CrowdLaunch strives to provide links to reputable sources, external websites are not managed or controlled by us.
        Please exercise caution when clicking on external links:
        <br />• Verify the URL to ensure it is the official website.
        <br />• Be wary of phishing attempts and scams.
        <br />• Ensure your wallet or personal information is secure and never shared on third-party sites.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        When you decide to leave CrowdLaunch via an external link, remember that you are transitioning
        to a website outside our control. We encourage you to verify the authenticity of external resources
        and always protect your personal information. Enjoy exploring beyond CrowdLaunch!
      </Typography>
    </Container>
  );
};

export default DocsLeavingCrowdLaunch;
